module.exports = __webpack_public_path__ + "img/astral_5.1cfcd913.svg";